<template>
  <div>
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      :disabled="isDetail"
      label-width="auto"
    >
      <el-row>
        <el-col :span="6">
          <div class="first-title">
            <span style="margin-left:10px;">基本信息</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="企业名称" prop="groupName">
            <el-input
              v-model.trim="form.groupName"
              placeholder="请输入企业名称"
              maxlength="256"
              clearable
              @change="
                value => {
                  form.groupName = value.replace(/\s/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="企业简称码" prop="organizationCode">
            <el-input
              v-model="form.organizationCode"
              placeholder="请输入2-6位字母"
              minlength="2"
              maxlength="6"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="企业简称" prop="groupNameLocal">
            <el-input
              v-model.trim="form.groupNameLocal"
              placeholder="请输入企业简称【发短信使用】"
              minlength="3"
              maxlength="7"
              clearable
              @change="
                value => {
                  form.groupNameLocal = value.replace(/\s/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col v-if="level" :span="6">
          <el-form-item label="平台名称" prop="platformName">
            <el-input
              v-model="form.platformName"
              placeholder="请输入平台名称"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="统一社会信用代码" prop="uniformSocialCreditCode">
            <el-input
              v-model="form.uniformSocialCreditCode"
              placeholder="请输入统一社会信用代码"
              maxlength="255"
              clearable
              @change="
                value => {
                  form.uniformSocialCreditCode = value.replace(/\W/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="道路运输证编号" prop="permitNumber">
            <el-input
              v-model="form.permitNumber"
              placeholder="请输入道路运输经营许可证编号"
              max="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="企业地址" prop="address">
            <el-input
              v-model="form.address"
              placeholder="请输入企业地址"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="企业网址" prop="wwwUrl">
            <el-input
              v-model="form.wwwUrl"
              placeholder="请输入企业网址"
              maxlength="255"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="400客服">
            <el-input
              v-model="form.telephone"
              placeholder="请输入400客服电话"
              maxlength="16"
              clearable
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="联系人" prop="contactName">
            <el-input
              v-model="form.contactName"
              placeholder="请输入联系人"
              maxlength="255"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="联系电话" prop="contactMobileTelephoneNumber">
            <el-input
              v-model="form.contactMobileTelephoneNumber"
              placeholder="请输入联系电话"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="单位性质" prop="vehicleLicenseColor">
            <el-select
              v-model="form.unitProperties"
              placeholder="请选择单位性质"
              clearable
            >
              <el-option
                v-for="item in unitPropertiesList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="营业执照期限开始日期"
            prop="businessLicenseStartDatetime"
          >
            <el-date-picker
              v-model="form.businessLicenseStartDatetime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd 00:00:00"
              :validate-event="false"
              placeholder="选择日期"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="营业执照期限结束日期"
            prop="businessLicenseEndDatetime"
          >
            <el-date-picker
              v-model="form.businessLicenseEndDatetime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd 00:00:00"
              :validate-event="false"
              placeholder="选择日期"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创建时间" prop="gmtCreated">
            <el-input
              v-model="form.gmtCreated"
              placeholder="请输入创建时间"
              clearable
              :disabled="true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="修改时间" prop="gmtModified">
            <el-input
              v-model="form.gmtModified"
              placeholder="请输入修改时间"
              :disabled="true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">
            <el-form-item label="卡对卡清分策略">
              <el-radio-group
                v-model="form.bankPayClearingStrategy"
                @change="bankPayChange"
              >
                <el-radio label="DRIVER_LEADER"> 支付给车队长 </el-radio>
                <el-radio label="DRIVER"> 支付给实际承运人 </el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="电子围栏" prop="limitStatus">
         
            <el-switch
              v-model="form.limitStatus"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
            />
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row style="margin-top:30px;">
        <el-col :span="18">
          <div class="first-title">
            <span style="margin-left:10px;">证件信息</span>
          </div>
        </el-col>
      </el-row>

      <el-form-item label="上传证件" required>
        <ImgUpload
          :upload-config="{
            lebal: '企业logo',
            prefix: 'logo',
            form: form,
            suffix: 'Url'
          }"
        />
        <ImgUpload
          :upload-config="{
            lebal: '登录logo',
            prefix: 'loginLogo',
            form: form,
            suffix: 'Url'
          }"
        />
        <ImgUpload
          :upload-config="{
            lebal: '统一社会信用代码',
            prefix: 'uniformSocialCreditCode',
            form: form,
            suffix: 'Url'
          }"
        />
        <ImgUpload
          :upload-config="{
            lebal: '电信增值业务许可证ICP',
            prefix: 'icpImg',
            form: form,
            suffix: ''
          }"
        />
        <ImgUpload
          :upload-config="{
            lebal: '软件著作权',
            prefix: 'softwareCopyrightImg',
            form: form,
            suffix: ''
          }"
        />
        <ImgUpload
          :upload-config="{
            lebal: '服务器租赁协议',
            prefix: 'serverLeasingAgreement',
            form: form,
            suffix: ''
          }"
        />
        <ImgUpload
          :upload-config="{
            lebal: '合同章',
            prefix: 'mis',
            form: form,
            suffix: 'Url'
          }"
          disabled
        />
      </el-form-item>
      <el-row v-if="!isDetail">
        <el-col :span="24">
          <el-form-item>
            <el-button
              v-if="getLimit('editPlateformCompany_creditMis_button')"
              type="primary"
              @click="creditMis"
            >
              生成合同章
            </el-button>
            <el-button
              v-if="getLimit('editPlateformCompany_submit_button')"
              type="primary"
              @click="funcSubmit"
            >
              确 定
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="isDetail" style="text-align:center">
      <el-button
        v-if="getLimit('editPlateformCompany_edit_button')"
        type="primary"
        @click="funcEdit"
      >
        编辑
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import ImgUpload from "@/components/ImgUpload";
import {
  isURL,
  isPartyGroupPrefix,
  isBusinessLicenseImgNum
} from "@/utils/validate4Form";
import { getListDict } from "@/api/shipment";
export default {
  name: "SysSetting",
  components: {
    ImgUpload
  },
  data() {
    return {
      // state:false,
      companyCode: "",
      isDetail: false,
      level: 1,
      form: {},
      unitPropertiesList: [],
      rules: {
        groupName: [
          {
            required: true,
            message: "请输入企业名称：机构/网点/入住企业",
            trigger: "blur"
          },
          {
            min: 1,
            max: 256,
            message: "长度在 1 到 256 个字符",
            trigger: "blur"
          }
        ],
        groupNameLocal: [
          {
            required: true,
            message: "请输入企业简称3-7字符",
            trigger: "blur"
          },
          {
            min: 3,
            max: 7,
            message: "长度在 3 到 7 个字符",
            trigger: "blur"
          }
        ],
        organizationCode: [
          {
            required: true,
            message: "请输入企业简称码",
            trigger: "blur"
          },
          { validator: isPartyGroupPrefix, trigger: "blur" },
          {
            min: 2,
            max: 6,
            message: "长度在 2 到 6 个字符",
            trigger: "blur"
          }
        ],
        wwwUrl: [
          {
            required: true,
            message: "请输入企业网址",
            trigger: "blur"
          },
          { validator: isURL, trigger: "blur" },
          {
            min: 1,
            max: 255,
            message: "长度在 1 到 255 个字符",
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            message: "请输入企业地址",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "长度在 1 到 255 个字符",
            trigger: "blur"
          }
        ],
        contactName: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "长度在 1 到 255 个字符",
            trigger: "blur"
          }
        ],
        contactMobileTelephoneNumber: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur"
          }
        ],
        uniformSocialCreditCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur"
          },
          { validator: isBusinessLicenseImgNum },
          {
            min: 1,
            max: 255,
            message: "长度在 1 到 255 个字符",
            trigger: "blur"
          }
        ],

        platformName: [
          {
            required: true,
            message: "请输入平台名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur"
          }
        ],
        permitNumber: [
          {
            required: true,
            message: "请输入道路运输经营许可证编号",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    // 获取路由
    this.companyCode = this.$route.query.code || "";
    this.level = this.$route.query.level == 0;
    this.isDetail = this.$route.query.prefix == "detail" ? true : false;
    this.getDict();
    this.getInfo(this.companyCode);
  },

  methods: {
    bankPayChange(e) {
      if (e == "DRIVER_LEADER") {
        this.$confirm(
          "此配置仅针对银行支付和转账支付两种（不支持清分的）支付模式，目前只有金昌税务（西部网络货运区块链服务）平台确认车队长（无资质承运商）可以通过代收协议的方式代替实际承运人收款，其他省份车队长（无资质承运商）代收运费有违规的风险，是否确认修改？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.form.bankPayClearingStrategy = e;
          })
          .catch(() => {
            this.form.bankPayClearingStrategy = "DRIVER";
          });
      } else if (e == "DRIVER") {
        this.$confirm(
          "此配置仅针对银行支付和转账支付两种（不支持清分的）支付模式，若需要将运费直接支付给实际承运人需要提前与车队长（无资质承运商）做好沟通工作，是否确认修改？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.form.bankPayClearingStrategy = e;
          })
          .catch(() => {
            this.form.bankPayClearingStrategy = "DRIVER_LEADER";
          });
      }
    },
    getDict() {
      getListDict({ types: "unitProperties" }).then(response => {
        this.unitPropertiesList = response.data[0].dictList;
      });
    },
    getInfo(code) {
      return request({
        url: `/ntocc-basic-api/partyGroup/${code}`,
        method: "get"
      }).then(response => {
        if (response.data) {
          // console.log('2233', response.data)
          this.form = response.data;
          if (!this.form.bankPayClearingStrategy) {
            this.form.bankPayClearingStrategy = "DRIVER_LEADER";
          }
        }
      });
    },
    creditMis() {
      return request({
        url: `/ntocc-basic-api/partyGroup/caculateCompanySeal`,
        method: "post",
        params: {
          uniformSocialCreditCode: this.form.uniformSocialCreditCode
        }
      }).then(response => {
        this.form.misUrl = response.data;
      });
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          if (data.code) {
            request({
              url: "/ntocc-basic-api/partyGroup",
              method: "put",
              params: data
            }).then(response => {
              this.getInfo(this.companyCode);
              rLoading.close();
              this.$message({
                message: response.msg,
                type: "success"
              });
              this.$store.dispatch("components/getBranchList");
            });
          } else {
            request({
              url: "/ntocc-basic-api/partyGroup",
              method: "post",
              params: data
            }).then(response => {
              this.getInfo(this.companyCode);
              rLoading.close();
              this.$message({
                message: response.msg,
                type: "success"
              });
              this.$store.dispatch("components/getBranchList");
            });
          }
        } else {
          return false;
        }
      });
    },
    funcEdit() {
      this.isDetail = false;
    }
  }
};
</script>
<style scoped>
.first-title {
  margin: 20px 0;
  font-size: 18px;
}

.first-title::before {
  content: "";
  height: 15px;
  width: 2px;
  background-color: #ff7f21;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style>
